<ion-card class="card-shadow-7" 
style="border-radius: 0.5em;height: 100%;"
>

<ion-grid class="ion-no-padding" style="color: black;">
<ion-row  style="background:var(--ion-color-standard-permit);">
  <ion-col style="padding: 0.4em;">
    <ion-label class="card-header-unique">STANDARD PERMIT</ion-label>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col style="padding: 0.5em;">
    <ion-label class="card-header-unique">#{{standardPermit['PermitNo']}}</ion-label>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col class="ion-no-padding">
    <h1 style="padding: 0.5em;margin: 0;" class="paragraph-bold"> <ion-icon
      style="vertical-align: middle; font-size: x-large;"
      name="location-outline"
    ></ion-icon
    >{{standardPermit['LotName']}}</h1>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-item lines="none">
    <ion-label  class="ion-text-wrap paragraph-regular">
      {{standardPermit['SemTitle']}}

    </ion-label>
    <span style="text-align: right;" class="ion-text-wrap paragraph-bold">
      {{standardPermit['amount'] | currency}}
    </span>
  </ion-item>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col style="text-align: center;padding-bottom: 0.3em;">
    <ion-chip style="font-weight: bold;" color="danger" *ngIf="standardPermit['prevent_rollover']=='1'" >
      {{('keys.data.permit::labels.renewal_not_renewing' | translate : {Default:'Not Renewing'}) || 'Not Renewing'}} 
     </ion-chip>
     <ion-chip style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;" *ngIf="standardPermit['prevent_rollover']!='1'" >
      {{('keys.data.permit::labels.renewal_renewing' | translate : {Default:'Renewing'}) || 'Renewing'}} 
     </ion-chip>
  </ion-col>
</ion-row>
</ion-grid>

 </ion-card>